import { createFileRoute } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId/invoice'
)({
  meta: () => [
    {
      title: LABELS.BILL
    }
  ]
})
